/* OTACI landing page — scroll reveals. Loaded once per page; guard against
   duplicate execution since multiple sections reference this asset. */
(function () {
  if (window.__otaciLandingInit) return;
  window.__otaciLandingInit = true;

  function revealAll() {
    document.querySelectorAll('.otaci-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  function init() {
    document.querySelectorAll('.otaci-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
